/* eslint-disable arrow-body-style */
/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Body, Container, Html, Section, Text, Button } from "@react-email/components";
import PropTypes from "prop-types";

import HeadSection from "../HeadSection";
import LogoSection from "../LogoSection";
import FooterSection from "../FooterSection";
import { formatDeliveryDetails } from "../../../components/helper";

const EmailToHotelService = ({ user = {}, data = {} }) => {
  const { roomNumber = "101" } = user;
  const {
    totalPax = 1,
    scheduleDate,
    requestTime = "asap",
    status,
    paymentMethod = "Cash",
    email = "guest@example.com",
    createdAt = new Date().toDateString(),
    items = [{ ref: { title: "Item 1" } }],
    token = "https://lokalee.app",
    tagName = "premium service",
    description = "This section should display the additional info from the ticket",
  } = data;
  const getStatus = (requestStatus, method) => {
    if (requestStatus) return requestStatus;
    return method === "stripe" ? "Paid" : "Pending";
  };

  return (
    <Html>
      <HeadSection />
      <Body
        style={{
          lineHeight: "1.625",
          backgroundColor: "#f7fafc",
          fontFamily: "Arial, sans-serif",
        }}
      >
        <Container
          style={{
            padding: "0",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
          }}
        >
          {/* Logo Section */}
          <LogoSection />

          {/* Greeting Section */}
          <Section
            style={{
              textAlign: "left",
              padding: "1.5rem 2rem 1rem 2rem",
            }}
          >
            <Text
              style={{
                fontSize: "24px",
                color: "#222D29",
                marginBottom: "1rem",
              }}
            >
              You have a pending {tagName} request from a guest. Kindly review the following details
              to ensure fulfillment within possibility.
            </Text>
          </Section>

          {/* Service Details Section */}
          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              margin: "0 auto 24px auto",
              backgroundColor: "#F2F2F2",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              SERVICE DETAILS
            </Text>

            <div style={{ display: "flex", marginBottom: "4px", margin: "0px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>
                Order Details:
              </Text>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {items.map((item) => item?.ref?.title || item.title).join(", ")}
              </Text>
            </div>
            {totalPax === "empty" ? null : (
              <div style={{ display: "flex", marginBottom: "4px" }}>
                <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>
                  Order Quantity:
                </Text>

                <Text
                  style={{
                    margin: "0px",
                    fontSize: "14px",
                    color: "#222D29",
                    fontWeight: "bold",
                  }}
                >
                  {totalPax}
                </Text>
              </div>
            )}

            <div style={{ display: "flex", marginBottom: "4px", margin: "0px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>
                Request Date & Time:
              </Text>

              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {createdAt}
              </Text>
            </div>

            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>
                Order Status:
              </Text>
              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {getStatus(status, paymentMethod)}
              </Text>
            </div>
          </Section>

          {/* Guest Details Section */}
          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 24px auto",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              GUEST DETAILS
            </Text>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>Last Name:</Text>

              <Text
                style={{
                  margin: "0px",
                  fontSize: "14px",
                  color: "#222D29",
                  fontWeight: "bold",
                }}
              >
                {email.split("@")[0]}
              </Text>
            </div>

            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>
                Room Number:
              </Text>

              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {roomNumber}
              </Text>
            </div>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text style={{ fontSize: "14px", color: "#222D29", margin: "0px" }}>Email:</Text>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {email}
              </Text>
            </div>
          </Section>

          {/* Additional Info Section */}
          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 24px auto",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              ADDITIONAL INFO
            </Text>
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
              }}
            >
              {description}
            </Text>
          </Section>

          {/* Delivery Details Section */}
          <Section
            style={{
              maxWidth: "536px",
              padding: "16px 24px",
              borderRadius: "11.54px",
              backgroundColor: "#F2F2F2",
              margin: "0 auto 24px auto",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "14px",
                color: "#222D29",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              DELIVERY DETAILS
            </Text>
            <div style={{ display: "flex", marginBottom: "4px" }}>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  color: "#222D29",
                  margin: "0px",
                }}
              >
                {formatDeliveryDetails(requestTime, scheduleDate)}
              </Text>
            </div>
          </Section>

          {token && paymentMethod !== "stripe" && (
            <Section style={{ padding: "0px 24px" }}>
              <Button
                href={token}
                style={{
                  width: "100%",
                  color: "#FFFFFF",
                  fontSize: "14px",
                  margin: "20px 0",
                  padding: "12px 0",
                  fontWeight: "600",
                  borderRadius: "4px",
                  textAlign: "center",
                  backgroundColor: "#222D29",
                }}
              >
                Confirm Request
              </Button>
            </Section>
          )}

          {/* Footer Section */}
          <Section
            style={{
              textAlign: "left",
              padding: "24px",
              borderTop: "1px solid #eaeaea",
            }}
          >
            <Text
              style={{
                margin: "0px",
                fontSize: "20px",
                fontWeight: "700",
                color: "#222D29",
                marginBottom: "20px",
              }}
            >
              Thank you,
            </Text>

            <Text style={{ fontSize: "20px", color: "#222D29", fontWeight: "400", margin: "0px" }}>
              Lokalee Operations Team
            </Text>
          </Section>
          <FooterSection hasSocialLinks={false} />
        </Container>
      </Body>
    </Html>
  );
};

export default EmailToHotelService;

EmailToHotelService.propTypes = {
  data: PropTypes.shape({}),
  user: PropTypes.shape({}),
};
